function Animal({ animal, onClick=null, className }) {
    const animalSrc = require(`../assets/animals/${animal}.svg`);

    if (!onClick) {
        return (
            <div key={animal} className={'bg-neutral-200 z-50 border border-neutral-500 rounded-lg p-1.5 ' + className} >
                <div className='aspect-square w-10 h-10'>
                    <img src={animalSrc} alt={animal}/>
                </div>
            </div>
        )
    } else {
        return (
            <div key={animal} onClick={onClick} className={'bg-neutral-200 z-50 border border-neutral-500 rounded-lg p-1.5 cursor-pointer hover:bg-neutral-400 transition ' + className}>                
                <div className='aspect-square w-10 h-10'>
                    <img src={animalSrc} alt={animal}/>
                </div>
            </div>
        )
    }

}

export default Animal;